import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import { GridItem } from 'src/components/common/grids';
import { SearchWrapper, BoldText } from '../../styles';
import SearchedProperties from '../../components/PropertyTables/SearchedProperties';
import MigrateStatusSelect from '../../components/PropertyTables/MigrateStatusSelect'
import { useContext } from 'react';
import { MigrateByIdContext } from '../..';

const MigrateByID = () => {
    const {
        searchPropertiesForm,
        searchedProperties,
        migrationByIdState,
        setMigrationByIdState,
        handleMigrateFromList,
        loadingMigration,
        loadingSearchedProperties
    } = useContext(MigrateByIdContext)
    return (
        <>
            <BoldText>Migrar buscando por ID</BoldText>

            <form onSubmit={searchPropertiesForm.handleSubmit}>
                <SearchWrapper>
                    <GridItem sm={4} md={6} lg={8}>
                        <TextField
                            dataId="propertyIds"
                            name="propertyIds"
                            label="Búsqueda por ID de la propiedad"
                            originType="pcom"
                            placeHolder="Digite los valores separados por comas"
                            innerLabel
                            value={searchPropertiesForm.values.propertyIds}
                            onChange={(_, _vale, e) => searchPropertiesForm.handleChange(e)}
                            error={Boolean(searchPropertiesForm.errors.propertyIds)}
                            errorMessage={JSON.stringify(searchPropertiesForm.errors.propertyIds)}
                            maxLength={3000}
                        />
                    </GridItem>

                    <GridItem sm={1} md={1} lg={1}>

                        <Button dataId="button-search" originType="pcom" fluid type="submit">
                            Buscar
                        </Button>
                    </GridItem>
                </SearchWrapper>
            </form>
            {searchedProperties.length > 0 &&
                <MigrateStatusSelect
                    value={migrationByIdState}
                    setValue={setMigrationByIdState}
                    text={"Migrar por Ids"}
                    handler={handleMigrateFromList}
                    loadingMigration={loadingMigration}
                />
            }
            <SearchedProperties
                searchedProperties={searchedProperties}
                loadingSearchedProperties={loadingSearchedProperties}
            />
        </>
    )
}

export default MigrateByID;